import { render } from "./DialogComponent.vue?vue&type=template&id=0e423fb6&ts=true"
import script from "./DialogComponent.vue?vue&type=script&lang=ts"
export * from "./DialogComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__